module.exports = __webpack_public_path__ + "static/media/generic-mq.b16ad528.jpeg";